export default "__VITE_ASSET__BQNtV_Dm__"